// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/quotations.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { CreateDealForDocumentRequest, DealInvoice, DocumentDealResponse } from "./deal_pb";
import { file_api_proto_v1_deal } from "./deal_pb";
import type { ImageResponse } from "./image_pb";
import { file_api_proto_v1_image } from "./image_pb";
import type { Order } from "./list_pb";
import { file_api_proto_v1_list } from "./list_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/quotations.proto.
 */
export const file_api_proto_v1_quotations: GenFile = /*@__PURE__*/
  fileDesc("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", [file_api_proto_v1_deal, file_api_proto_v1_image, file_api_proto_v1_list, file_google_protobuf_timestamp, file_google_protobuf_wrappers]);

/**
 * @generated from message api_proto.v1.QuotationDetailGroup
 */
export type QuotationDetailGroup = Message<"api_proto.v1.QuotationDetailGroup"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: google.protobuf.StringValue remark = 2;
   */
  remark?: string;

  /**
   * @generated from field: int64 order_index = 3;
   */
  orderIndex: bigint;

  /**
   * @generated from field: double amount = 4;
   */
  amount: number;

  /**
   * @generated from field: repeated api_proto.v1.QuotationDetail details = 5;
   */
  details: QuotationDetail[];

  /**
   * 端数調整(税抜)
   *
   * @generated from field: int64 adjustment = 6;
   */
  adjustment: bigint;

  /**
   * 端数調整(税込)
   *
   * @generated from field: int64 adjustment_tax = 7;
   */
  adjustmentTax: bigint;
};

/**
 * Describes the message api_proto.v1.QuotationDetailGroup.
 * Use `create(QuotationDetailGroupSchema)` to create a new message.
 */
export const QuotationDetailGroupSchema: GenMessage<QuotationDetailGroup> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_quotations, 0);

/**
 * 見積詳細の原価情報（正規化テーブル: quotation_detail_costs）
 *
 * @generated from message api_proto.v1.QuotationDetailCost
 */
export type QuotationDetailCost = Message<"api_proto.v1.QuotationDetailCost"> & {
  /**
   * 原価入力方式
   *
   * @generated from field: api_proto.v1.CostInputType cost_input_type = 1;
   */
  costInputType: CostInputType;

  /**
   * 原価単価（cost_input_type=UNIT_PRICEの場合に使用）
   *
   * @generated from field: google.protobuf.Int64Value cost_unit_price = 2;
   */
  costUnitPrice?: bigint;

  /**
   * 原価合計（cost_input_type=TOTALの場合、または計算結果）
   *
   * @generated from field: google.protobuf.Int64Value cost_total = 3;
   */
  costTotal?: bigint;

  /**
   * 原価説明
   *
   * @generated from field: google.protobuf.StringValue cost_description = 4;
   */
  costDescription?: string;
};

/**
 * Describes the message api_proto.v1.QuotationDetailCost.
 * Use `create(QuotationDetailCostSchema)` to create a new message.
 */
export const QuotationDetailCostSchema: GenMessage<QuotationDetailCost> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_quotations, 1);

/**
 * @generated from message api_proto.v1.QuotationDetail
 */
export type QuotationDetail = Message<"api_proto.v1.QuotationDetail"> & {
  /**
   * @generated from field: google.protobuf.StringValue description = 1;
   */
  description?: string;

  /**
   * @generated from field: google.protobuf.StringValue remark = 2;
   */
  remark?: string;

  /**
   * @generated from field: google.protobuf.DoubleValue quantity = 3;
   */
  quantity?: number;

  /**
   * @generated from field: google.protobuf.StringValue unit = 4;
   */
  unit?: string;

  /**
   * @generated from field: google.protobuf.Int64Value unit_price = 5;
   */
  unitPrice?: bigint;

  /**
   * @generated from field: int64 order_index = 6;
   */
  orderIndex: bigint;

  /**
   * 原価情報（Optional、見積書のみ対応）
   *
   * @generated from field: optional api_proto.v1.QuotationDetailCost cost = 7;
   */
  cost?: QuotationDetailCost;
};

/**
 * Describes the message api_proto.v1.QuotationDetail.
 * Use `create(QuotationDetailSchema)` to create a new message.
 */
export const QuotationDetailSchema: GenMessage<QuotationDetail> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_quotations, 2);

/**
 * @generated from message api_proto.v1.CreateQuotationRequest
 */
export type CreateQuotationRequest = Message<"api_proto.v1.CreateQuotationRequest"> & {
  /**
   * @generated from field: google.protobuf.StringValue name = 1;
   */
  name?: string;

  /**
   * @generated from field: google.protobuf.StringValue number = 2;
   */
  number?: string;

  /**
   * @generated from field: google.protobuf.Timestamp quotation_at = 3;
   */
  quotationAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp expire_at = 4;
   */
  expireAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.StringValue remark = 5;
   */
  remark?: string;

  /**
   * @generated from field: string company_name = 6;
   */
  companyName: string;

  /**
   * @generated from field: google.protobuf.StringValue company_address = 7;
   */
  companyAddress?: string;

  /**
   * @generated from field: google.protobuf.StringValue company_contact = 8;
   */
  companyContact?: string;

  /**
   * @generated from field: google.protobuf.StringValue company_registration_number = 9;
   */
  companyRegistrationNumber?: string;

  /**
   * @generated from field: google.protobuf.StringValue company_bank_account = 10;
   */
  companyBankAccount?: string;

  /**
   * @generated from field: google.protobuf.Int64Value company_logo_id = 11;
   */
  companyLogoId?: bigint;

  /**
   * @generated from field: google.protobuf.Int64Value company_seal_id = 12;
   */
  companySealId?: bigint;

  /**
   * @generated from field: int64 customer_id = 13;
   */
  customerId: bigint;

  /**
   * @generated from field: string customer_name = 14;
   */
  customerName: string;

  /**
   * @generated from field: string honorific = 15;
   */
  honorific: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_zipcode = 16;
   */
  customerZipcode?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_prefecture = 17;
   */
  customerPrefecture?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_city = 18;
   */
  customerCity?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_street = 19;
   */
  customerStreet?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_department = 21;
   */
  customerDepartment?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_contact_person = 22;
   */
  customerContactPerson?: string;

  /**
   * @generated from field: int64 company_staff_id = 23;
   */
  companyStaffId: bigint;

  /**
   * @generated from field: string format_type = 24;
   */
  formatType: string;

  /**
   * format_typeがsingleの場合details、multipleの場合detail_groupsがセットされる
   *
   * @generated from field: repeated api_proto.v1.QuotationDetail details = 25;
   */
  details: QuotationDetail[];

  /**
   * @generated from field: repeated api_proto.v1.QuotationDetailGroup detail_groups = 26;
   */
  detailGroups: QuotationDetailGroup[];

  /**
   * 端数調整
   *
   * 端数調整(税抜)
   *
   * @generated from field: int64 adjustment = 27;
   */
  adjustment: bigint;

  /**
   * 端数調整(税込)
   *
   * @generated from field: int64 adjustment_tax = 28;
   */
  adjustmentTax: bigint;

  /**
   * レイアウトタイプ: normal=通常, windowed=窓付封筒
   *
   * @generated from field: string layout_type = 29;
   */
  layoutType: string;

  /**
   * 案件連携（新規作成時のみ）
   *
   * @generated from field: google.protobuf.Int64Value deal_id = 30;
   */
  dealId?: bigint;
};

/**
 * Describes the message api_proto.v1.CreateQuotationRequest.
 * Use `create(CreateQuotationRequestSchema)` to create a new message.
 */
export const CreateQuotationRequestSchema: GenMessage<CreateQuotationRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_quotations, 3);

/**
 * @generated from message api_proto.v1.CreateQuotationResponse
 */
export type CreateQuotationResponse = Message<"api_proto.v1.CreateQuotationResponse"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * 見積書番号が重複していた場合true
   *
   * @generated from field: bool number_duplicate = 2;
   */
  numberDuplicate: boolean;
};

/**
 * Describes the message api_proto.v1.CreateQuotationResponse.
 * Use `create(CreateQuotationResponseSchema)` to create a new message.
 */
export const CreateQuotationResponseSchema: GenMessage<CreateQuotationResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_quotations, 4);

/**
 * @generated from message api_proto.v1.UpdateQuotationRequest
 */
export type UpdateQuotationRequest = Message<"api_proto.v1.UpdateQuotationRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: google.protobuf.StringValue name = 2;
   */
  name?: string;

  /**
   * @generated from field: google.protobuf.StringValue number = 3;
   */
  number?: string;

  /**
   * @generated from field: google.protobuf.Timestamp quotation_at = 4;
   */
  quotationAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp expire_at = 5;
   */
  expireAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.StringValue remark = 6;
   */
  remark?: string;

  /**
   * @generated from field: string company_name = 7;
   */
  companyName: string;

  /**
   * @generated from field: google.protobuf.StringValue company_address = 8;
   */
  companyAddress?: string;

  /**
   * @generated from field: google.protobuf.StringValue company_contact = 9;
   */
  companyContact?: string;

  /**
   * @generated from field: google.protobuf.StringValue company_registration_number = 10;
   */
  companyRegistrationNumber?: string;

  /**
   * @generated from field: google.protobuf.StringValue company_bank_account = 11;
   */
  companyBankAccount?: string;

  /**
   * @generated from field: google.protobuf.Int64Value company_logo_id = 12;
   */
  companyLogoId?: bigint;

  /**
   * @generated from field: google.protobuf.Int64Value company_seal_id = 13;
   */
  companySealId?: bigint;

  /**
   * @generated from field: int64 customer_id = 14;
   */
  customerId: bigint;

  /**
   * @generated from field: string customer_name = 15;
   */
  customerName: string;

  /**
   * @generated from field: string honorific = 16;
   */
  honorific: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_zipcode = 17;
   */
  customerZipcode?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_prefecture = 18;
   */
  customerPrefecture?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_city = 19;
   */
  customerCity?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_street = 20;
   */
  customerStreet?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_department = 22;
   */
  customerDepartment?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_contact_person = 23;
   */
  customerContactPerson?: string;

  /**
   * @generated from field: int64 company_staff_id = 24;
   */
  companyStaffId: bigint;

  /**
   * @generated from field: string format_type = 25;
   */
  formatType: string;

  /**
   * format_typeがsingleの場合details、multipleの場合detail_groupsがセットされる
   *
   * @generated from field: repeated api_proto.v1.QuotationDetail details = 26;
   */
  details: QuotationDetail[];

  /**
   * @generated from field: repeated api_proto.v1.QuotationDetailGroup detail_groups = 27;
   */
  detailGroups: QuotationDetailGroup[];

  /**
   * 端数調整
   *
   * 端数調整(税抜)
   *
   * @generated from field: int64 adjustment = 28;
   */
  adjustment: bigint;

  /**
   * 端数調整(税込)
   *
   * @generated from field: int64 adjustment_tax = 29;
   */
  adjustmentTax: bigint;

  /**
   * レイアウトタイプ: normal=通常, windowed=窓付封筒
   *
   * @generated from field: string layout_type = 30;
   */
  layoutType: string;
};

/**
 * Describes the message api_proto.v1.UpdateQuotationRequest.
 * Use `create(UpdateQuotationRequestSchema)` to create a new message.
 */
export const UpdateQuotationRequestSchema: GenMessage<UpdateQuotationRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_quotations, 5);

/**
 * @generated from message api_proto.v1.UpdateQuotationResponse
 */
export type UpdateQuotationResponse = Message<"api_proto.v1.UpdateQuotationResponse"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * 見積書番号が重複していた場合true
   *
   * @generated from field: bool number_duplicate = 2;
   */
  numberDuplicate: boolean;
};

/**
 * Describes the message api_proto.v1.UpdateQuotationResponse.
 * Use `create(UpdateQuotationResponseSchema)` to create a new message.
 */
export const UpdateQuotationResponseSchema: GenMessage<UpdateQuotationResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_quotations, 6);

/**
 * @generated from message api_proto.v1.QuotationListItem
 */
export type QuotationListItem = Message<"api_proto.v1.QuotationListItem"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string number = 3;
   */
  number: string;

  /**
   * @generated from field: string customer_name = 4;
   */
  customerName: string;

  /**
   * @generated from field: google.protobuf.Timestamp quotation_at = 5;
   */
  quotationAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp expire_at = 6;
   */
  expireAt?: Timestamp;

  /**
   * @generated from field: double total_amount = 7;
   */
  totalAmount: number;

  /**
   * @generated from field: double tax_rate = 8;
   */
  taxRate: number;

  /**
   * 端数調整
   *
   * 端数調整(税抜)
   *
   * @generated from field: int64 adjustment = 9;
   */
  adjustment: bigint;

  /**
   * 端数調整(税込)
   *
   * @generated from field: int64 adjustment_tax = 10;
   */
  adjustmentTax: bigint;

  /**
   * 調整後合計金額
   *
   * @generated from field: double adjusted_total_amount = 11;
   */
  adjustedTotalAmount: number;

  /**
   * 紐づく案件（未紐付けの場合は未設定）。案件名・ステータスを表示し、案件詳細へ遷移する
   *
   * @generated from field: optional api_proto.v1.DocumentDealResponse deal = 12;
   */
  deal?: DocumentDealResponse;

  /**
   * 紐づく案件に連携された請求書一覧（案件未紐付けなら空）
   *
   * @generated from field: repeated api_proto.v1.DealInvoice linked_invoices = 13;
   */
  linkedInvoices: DealInvoice[];
};

/**
 * Describes the message api_proto.v1.QuotationListItem.
 * Use `create(QuotationListItemSchema)` to create a new message.
 */
export const QuotationListItemSchema: GenMessage<QuotationListItem> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_quotations, 7);

/**
 * @generated from message api_proto.v1.GetQuotationListResponse
 */
export type GetQuotationListResponse = Message<"api_proto.v1.GetQuotationListResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.QuotationListItem quotations = 1;
   */
  quotations: QuotationListItem[];

  /**
   * @generated from field: int64 total_page = 2;
   */
  totalPage: bigint;
};

/**
 * Describes the message api_proto.v1.GetQuotationListResponse.
 * Use `create(GetQuotationListResponseSchema)` to create a new message.
 */
export const GetQuotationListResponseSchema: GenMessage<GetQuotationListResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_quotations, 8);

/**
 * @generated from message api_proto.v1.GetQuotationListRequest
 */
export type GetQuotationListRequest = Message<"api_proto.v1.GetQuotationListRequest"> & {
  /**
   * @generated from field: int64 page = 1;
   */
  page: bigint;

  /**
   * @generated from field: int64 page_size = 2;
   */
  pageSize: bigint;

  /**
   * @generated from field: repeated string free_words = 4;
   */
  freeWords: string[];

  /**
   * @generated from field: api_proto.v1.Order number_order = 5;
   */
  numberOrder: Order;

  /**
   * @generated from field: api_proto.v1.Order quotation_at_order = 6;
   */
  quotationAtOrder: Order;

  /**
   * @generated from field: api_proto.v1.Order expire_at_order = 7;
   */
  expireAtOrder: Order;

  /**
   * @generated from field: api_proto.v1.Order total_amount_order = 8;
   */
  totalAmountOrder: Order;
};

/**
 * Describes the message api_proto.v1.GetQuotationListRequest.
 * Use `create(GetQuotationListRequestSchema)` to create a new message.
 */
export const GetQuotationListRequestSchema: GenMessage<GetQuotationListRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_quotations, 9);

/**
 * @generated from message api_proto.v1.GetQuotationRequest
 */
export type GetQuotationRequest = Message<"api_proto.v1.GetQuotationRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;
};

/**
 * Describes the message api_proto.v1.GetQuotationRequest.
 * Use `create(GetQuotationRequestSchema)` to create a new message.
 */
export const GetQuotationRequestSchema: GenMessage<GetQuotationRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_quotations, 10);

/**
 * @generated from message api_proto.v1.GetQuotationResponse
 */
export type GetQuotationResponse = Message<"api_proto.v1.GetQuotationResponse"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: google.protobuf.StringValue name = 2;
   */
  name?: string;

  /**
   * @generated from field: google.protobuf.StringValue number = 3;
   */
  number?: string;

  /**
   * @generated from field: google.protobuf.Timestamp quotation_at = 4;
   */
  quotationAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp expire_at = 5;
   */
  expireAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.StringValue remark = 6;
   */
  remark?: string;

  /**
   * @generated from field: string company_name = 7;
   */
  companyName: string;

  /**
   * @generated from field: google.protobuf.StringValue company_address = 8;
   */
  companyAddress?: string;

  /**
   * @generated from field: google.protobuf.StringValue company_contact = 9;
   */
  companyContact?: string;

  /**
   * @generated from field: google.protobuf.StringValue company_registration_number = 10;
   */
  companyRegistrationNumber?: string;

  /**
   * @generated from field: google.protobuf.StringValue company_bank_account = 11;
   */
  companyBankAccount?: string;

  /**
   * @generated from field: optional api_proto.v1.ImageResponse logo = 12;
   */
  logo?: ImageResponse;

  /**
   * @generated from field: optional api_proto.v1.ImageResponse seal = 13;
   */
  seal?: ImageResponse;

  /**
   * @generated from field: int64 customer_id = 14;
   */
  customerId: bigint;

  /**
   * @generated from field: string customer_name = 15;
   */
  customerName: string;

  /**
   * @generated from field: string honorific = 16;
   */
  honorific: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_zipcode = 17;
   */
  customerZipcode?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_prefecture = 18;
   */
  customerPrefecture?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_city = 19;
   */
  customerCity?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_street = 20;
   */
  customerStreet?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_department = 22;
   */
  customerDepartment?: string;

  /**
   * @generated from field: google.protobuf.StringValue customer_contact_person = 23;
   */
  customerContactPerson?: string;

  /**
   * @generated from field: int64 company_staff_id = 24;
   */
  companyStaffId: bigint;

  /**
   * @generated from field: double tax_rate = 25;
   */
  taxRate: number;

  /**
   * @generated from field: double total_amount = 26;
   */
  totalAmount: number;

  /**
   * @generated from field: string format_type = 27;
   */
  formatType: string;

  /**
   * format_typeがsingleの場合details、multipleの場合detail_groupsがセットされる
   *
   * @generated from field: repeated api_proto.v1.QuotationDetail details = 28;
   */
  details: QuotationDetail[];

  /**
   * @generated from field: repeated api_proto.v1.QuotationDetailGroup detail_groups = 29;
   */
  detailGroups: QuotationDetailGroup[];

  /**
   * @generated from field: optional api_proto.v1.DocumentDealResponse deal = 30;
   */
  deal?: DocumentDealResponse;

  /**
   * 端数調整
   *
   * 端数調整(税抜)
   *
   * @generated from field: int64 adjustment = 31;
   */
  adjustment: bigint;

  /**
   * 端数調整(税込)
   *
   * @generated from field: int64 adjustment_tax = 32;
   */
  adjustmentTax: bigint;

  /**
   * 調整後合計金額
   *
   * @generated from field: double adjusted_total_amount = 33;
   */
  adjustedTotalAmount: number;

  /**
   * レイアウトタイプ: normal=通常, windowed=窓付封筒
   *
   * @generated from field: string layout_type = 34;
   */
  layoutType: string;

  /**
   * 原価・粗利情報（サーバー側で計算）
   *
   * 原価合計
   *
   * @generated from field: double cost_total_amount = 35;
   */
  costTotalAmount: number;

  /**
   * 粗利（売上 - 原価）
   *
   * @generated from field: double gross_profit = 36;
   */
  grossProfit: number;

  /**
   * 粗利率（%）
   *
   * @generated from field: double gross_profit_rate = 37;
   */
  grossProfitRate: number;
};

/**
 * Describes the message api_proto.v1.GetQuotationResponse.
 * Use `create(GetQuotationResponseSchema)` to create a new message.
 */
export const GetQuotationResponseSchema: GenMessage<GetQuotationResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_quotations, 11);

/**
 * @generated from message api_proto.v1.DeleteQuotationRequest
 */
export type DeleteQuotationRequest = Message<"api_proto.v1.DeleteQuotationRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;
};

/**
 * Describes the message api_proto.v1.DeleteQuotationRequest.
 * Use `create(DeleteQuotationRequestSchema)` to create a new message.
 */
export const DeleteQuotationRequestSchema: GenMessage<DeleteQuotationRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_quotations, 12);

/**
 * @generated from message api_proto.v1.GenerateQuotationNumberRequest
 */
export type GenerateQuotationNumberRequest = Message<"api_proto.v1.GenerateQuotationNumberRequest"> & {
};

/**
 * Describes the message api_proto.v1.GenerateQuotationNumberRequest.
 * Use `create(GenerateQuotationNumberRequestSchema)` to create a new message.
 */
export const GenerateQuotationNumberRequestSchema: GenMessage<GenerateQuotationNumberRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_quotations, 13);

/**
 * @generated from message api_proto.v1.GenerateQuotationNumberResponse
 */
export type GenerateQuotationNumberResponse = Message<"api_proto.v1.GenerateQuotationNumberResponse"> & {
  /**
   * @generated from field: string number = 1;
   */
  number: string;

  /**
   * 最後に使用した書類のフォーマット種別（"single" | "multiple"）。過去書類なければ空文字
   *
   * @generated from field: string last_format_type = 2;
   */
  lastFormatType: string;

  /**
   * 最後に使用した書類のレイアウト種別（"normal" | "windowed"）。過去書類なければ空文字
   *
   * @generated from field: string last_layout_type = 3;
   */
  lastLayoutType: string;
};

/**
 * Describes the message api_proto.v1.GenerateQuotationNumberResponse.
 * Use `create(GenerateQuotationNumberResponseSchema)` to create a new message.
 */
export const GenerateQuotationNumberResponseSchema: GenMessage<GenerateQuotationNumberResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_quotations, 14);

/**
 * @generated from message api_proto.v1.LinkDealToQuotationRequest
 */
export type LinkDealToQuotationRequest = Message<"api_proto.v1.LinkDealToQuotationRequest"> & {
  /**
   * @generated from field: int64 quotation_id = 1;
   */
  quotationId: bigint;

  /**
   * @generated from field: int64 deal_id = 2;
   */
  dealId: bigint;

  /**
   * 書類の情報で案件を保存したいかどうか
   *
   * @generated from field: bool want_update = 3;
   */
  wantUpdate: boolean;
};

/**
 * Describes the message api_proto.v1.LinkDealToQuotationRequest.
 * Use `create(LinkDealToQuotationRequestSchema)` to create a new message.
 */
export const LinkDealToQuotationRequestSchema: GenMessage<LinkDealToQuotationRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_quotations, 15);

/**
 * @generated from message api_proto.v1.LinkDealToQuotationResponse
 */
export type LinkDealToQuotationResponse = Message<"api_proto.v1.LinkDealToQuotationResponse"> & {
  /**
   * @generated from field: int64 quotation_id = 1;
   */
  quotationId: bigint;

  /**
   * @generated from field: int64 deal_id = 2;
   */
  dealId: bigint;
};

/**
 * Describes the message api_proto.v1.LinkDealToQuotationResponse.
 * Use `create(LinkDealToQuotationResponseSchema)` to create a new message.
 */
export const LinkDealToQuotationResponseSchema: GenMessage<LinkDealToQuotationResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_quotations, 16);

/**
 * @generated from message api_proto.v1.CreateAndLinkDealToQuotationRequest
 */
export type CreateAndLinkDealToQuotationRequest = Message<"api_proto.v1.CreateAndLinkDealToQuotationRequest"> & {
  /**
   * @generated from field: int64 quotation_id = 1;
   */
  quotationId: bigint;

  /**
   * @generated from field: api_proto.v1.CreateDealForDocumentRequest deal = 2;
   */
  deal?: CreateDealForDocumentRequest;
};

/**
 * Describes the message api_proto.v1.CreateAndLinkDealToQuotationRequest.
 * Use `create(CreateAndLinkDealToQuotationRequestSchema)` to create a new message.
 */
export const CreateAndLinkDealToQuotationRequestSchema: GenMessage<CreateAndLinkDealToQuotationRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_quotations, 17);

/**
 * @generated from message api_proto.v1.UnlinkDealFromQuotationRequest
 */
export type UnlinkDealFromQuotationRequest = Message<"api_proto.v1.UnlinkDealFromQuotationRequest"> & {
  /**
   * @generated from field: int64 quotation_id = 1;
   */
  quotationId: bigint;
};

/**
 * Describes the message api_proto.v1.UnlinkDealFromQuotationRequest.
 * Use `create(UnlinkDealFromQuotationRequestSchema)` to create a new message.
 */
export const UnlinkDealFromQuotationRequestSchema: GenMessage<UnlinkDealFromQuotationRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_quotations, 18);

/**
 * 原価入力方式
 *
 * @generated from enum api_proto.v1.CostInputType
 */
export enum CostInputType {
  /**
   * @generated from enum value: COST_INPUT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 単価入力
   *
   * @generated from enum value: COST_INPUT_TYPE_UNIT_PRICE = 1;
   */
  UNIT_PRICE = 1,

  /**
   * 合計入力
   *
   * @generated from enum value: COST_INPUT_TYPE_TOTAL = 2;
   */
  TOTAL = 2,
}

/**
 * Describes the enum api_proto.v1.CostInputType.
 */
export const CostInputTypeSchema: GenEnum<CostInputType> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_quotations, 0);

